var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcoQueue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.57143 3.28571H3.28571C2.67951 3.28571 2.09812 3.52653 1.66947 3.95518C1.24082 4.38384 1 4.96522 1 5.57143V19.2857C1 19.8919 1.24082 20.4733 1.66947 20.902C2.09812 21.3306 2.67951 21.5714 3.28571 21.5714H14.7143C15.3205 21.5714 15.9019 21.3306 16.3305 20.902C16.7592 20.4733 17 19.8919 17 19.2857V5.57143C17 4.96522 16.7592 4.38384 16.3305 3.95518C15.9019 3.52653 15.3205 3.28571 14.7143 3.28571H12.4286M5.57143 3.28571C5.57143 3.89192 5.81224 4.4733 6.2409 4.90196C6.66955 5.33061 7.25093 5.57143 7.85714 5.57143H10.1429C10.7491 5.57143 11.3304 5.33061 11.7591 4.90196C12.1878 4.4733 12.4286 3.89192 12.4286 3.28571M5.57143 3.28571C5.57143 2.67951 5.81224 2.09812 6.2409 1.66947C6.66955 1.24082 7.25093 1 7.85714 1H10.1429C10.7491 1 11.3304 1.24082 11.7591 1.66947C12.1878 2.09812 12.4286 2.67951 12.4286 3.28571M5.57143 13.5714L7.85714 15.8571L12.4286 11.2857",
    stroke: "#131415",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoQueue);
export default __webpack_public_path__ + "static/media/ico_queue.d179afb1321901162355abbae41bfd23.svg";
export { ForwardRef as ReactComponent };